const HOTELS_SEARCH_ADULTS_COUNT = 2
const ACTIVITIES_GROUP_OFFERS_BY = 'serviceName'

const HEADER_BAR_THEME_DARK = false
const B2C_HAS_ACCESS_TO_REGISTRATION = true

export default {
    HOTELS_SEARCH_ADULTS_COUNT,
    ACTIVITIES_GROUP_OFFERS_BY,
    HEADER_BAR_THEME_DARK,
    B2C_HAS_ACCESS_TO_REGISTRATION,
}
